module.exports = __webpack_public_path__ + "img/acuerdoCapte06.2c8297ad.jpg";